import { render } from "./CoffeeTupTixTineT6.vue?vue&type=template&id=0dde71e5"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CoffeeTupTixTineT6.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dde71e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dde71e5', __exports__)) {
    api.reload('0dde71e5', __exports__)
  }
  
  module.hot.accept("./CoffeeTupTixTineT6.vue?vue&type=template&id=0dde71e5", () => {
    api.rerender('0dde71e5', render)
  })

}


export default __exports__